<template lang="pug">
    div(
        data-pp-message
        :data-pp-offer="type"
        :data-pp-style-text-align="alignment"
    )
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return ['PAY_LATER_SHORT_TERM', 'PAY_LATER_LONG_TERM'].includes(value)
            },
        },
        alignment: {
            type: String,
            default: 'center',
            validator(value) {
                return ['left', 'center', 'right'].includes(value)
            },
        },
    },
    mounted() {
        this.refreshMessage()
    },
    methods: {
        refreshMessage() {
            this.$paypal.display.load(() => {
                if (window.paypal) return this.renderMessage()
                let counter = 0
                const interval = setInterval(() => {
                    if (window.paypal) {
                        clearInterval(interval)
                        this.renderMessage()
                    } else if (counter >= 10) {
                        this.$log.warning('paypal messaging display error', { counter })
                        clearInterval(interval)
                    }
                    counter++
                }, 1000)
            })
        },
        renderMessage() {
            // This will try to render new paypal messages
            window.paypal.Messages.render()
        },
    },
}
</script>
